<template>
  <div class="register_container">
    <div class="register_box">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-link class="link2" v-if="active1===1" type="primary" icon="el-icon-back" href="#/login">Login</el-link>
        </el-col>
        <el-col :span="24" style="text-align: center">
          <h2>Registered account</h2>
        </el-col>
<!--        <el-col :span="4">-->
<!--          <el-link class="link1" v-if="active1===1" type="primary" icon="el-icon-edit" href="#/companyregister">点这注册单位会员</el-link>-->
<!--        </el-col>-->
      </el-row>


      <el-row style="margin-top: 25px" :gutter="15">
        <el-col  :span="0.5">
          <div style="width: 5px;height: 35px;background-color:#409EFF;margin-left: 15px"></div>
        </el-col>
        <el-col  :span="8" style="">
          <h4 style="color: #409EFF;margin: 5px 0 0 0">The registration process</h4>
        </el-col>
      </el-row>
      <el-row>
        <el-col  :span="24">
          <el-steps :active="active1" align-center style="background:#DCDFE6;height: 70px;padding-top: 40px;margin-top: 25px">
<!--            <el-step title="注册须知"></el-step>-->
            <el-step title="The information submitted"></el-step>
            <el-step title="Registration completed"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <div v-if="this.active1 === 1" class="registerForm2" style="width: 800px;position: relative;left: 55%;transform: translate(-50%);">
        <div class="verticalLine2"></div>
        <h4 class="title2">Please enter the personal information</h4>
        <el-form ref="registerFormRef" :model="registerForm" label-width="100px" :rules="registerFormRules" class="register_form" >
          <el-form-item prop="email" required label="Email">
            <el-input v-model="registerForm.email" placeholder="Please enter your email address"></el-input>
          </el-form-item>
          <!--    用户名-->
          <el-form-item prop="password" required label="Password" style="margin-bottom: 35px">
            <el-input v-model="registerForm.password" placeholder="Please enter your password" type="password"></el-input>
          </el-form-item>
          <!--    用户名-->
          <el-form-item prop="checkPass" required label="Confirmed Password">
            <el-input v-model="registerForm.checkPass" placeholder="Please enter your password again" type="password"></el-input>
          </el-form-item>
          <el-form-item prop="firstName" required label="First Name">
            <el-input v-model="registerForm.firstName" placeholder="Please enter your first name"></el-input>
          </el-form-item>
          <el-form-item prop="lastName" required label="Last Name">
            <el-input v-model="registerForm.lastName" placeholder="Please enter your last name"></el-input>
          </el-form-item>
          <el-form-item prop="title" required label="Title">
            <el-input v-model="registerForm.title" placeholder="Please enter your title"></el-input>
          </el-form-item>
<!--          <el-form-item prop="phonenumber" required label="Tel">-->
<!--            <el-input v-model="registerForm.phonenumber" placeholder="Please enter your tel"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item prop="unitName" required label="Affiliation">
            <el-input v-model="registerForm.unitName" placeholder="Please enter your affiliation"></el-input>
          </el-form-item>
          <el-form-item prop="address" required label="Address">
            <el-input v-model="registerForm.address" placeholder="Please enter your address"></el-input>
          </el-form-item>
          <el-form-item prop="city" required label="City">
            <el-input v-model="registerForm.city" placeholder="Please enter your city"></el-input>
          </el-form-item>
          <el-form-item prop="country" required label="Country">
            <el-input v-model="registerForm.country" placeholder="Please enter your country"></el-input>
          </el-form-item>
          <el-form-item class="btns">
            <el-button class="button1" type="primary" @click="register">submit</el-button>
            <el-button class="button2" type="info" @click="toLogin">cancel</el-button>
<!--            <el-button class="button3" type="warning" @click="toLast">返回上一级</el-button>-->
          </el-form-item>
        </el-form>
      </div>

      <div v-if="this.active1 === 2" class="registerForm3">
        <el-result icon="success" title="Registered successfully" subTitle="Please return to the login page to log in" style="margin-top: 50px">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="toLogin">return</el-button>
          </template>
        </el-result>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  data () {
    //验证邮箱
    var chekEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式 /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
      const regEmail = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
      if (value === '') {
        callback(new Error('Please enter email address'));
      } else {
        if (regEmail.test(value)) {
          // 合法的邮箱
          callback()
        } else {
          callback(new Error('Please enter a valid email address'))
        }

      }
    }
    //验证两次密码是否一致
    const pass = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,}$/
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Please enter your password'));
      }else if(!pass.test(value)){
        callback(new Error('Enter 8 to 20 characters, including at least three combinations of uppercase and lowercase letters, digits, and special characters'))
      } else {
        if (this.registerForm.checkPass !== '') {
          this.$refs.registerFormRef.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password again'));
      } else if (value !== this.registerForm.password) {
        callback(new Error('The two passwords are not the same!'));
      } else {
        callback();
      }
    };
    return {

      active1:this.$store.state.active1,
      // active1:3,
      //发送验证码
      isSend: true,
      sendmsg: 'Send verification code',
      // 注册表单的数据对象
      registerForm: {
        email:'',
        password:'',
        checkPass:'',
        firstName:'',
        lastName:'',
        title:'',
        phonenumber:'',
        unitName:'',
        address:'',
        city:'',
        country:'',
        confId:'',
      },
      // 表单的验证规则
      registerFormRules: {
        //验证邮箱
        email: [
          { validator: chekEmail,trigger: 'blur'}
        ],
        // 验证密码
        password: [
          { validator: validatePass,trigger: 'blur'}
        ],
        //  验证密码是否合法
        checkPass: [
          { validator: validatePass2, trigger: 'blur'}
        ],

        //验证单位
        unitName:[
          {required:true,trigger:'blur',message: "Please enter your affiliation"}
        ],
        firstName: [
          {required:true,trigger:'blur',message: "Please enter your firstName"}
        ],
        lastName: [
          {required:true,trigger:'blur',message: "Please enter your lastName"}
        ],
        title: [
          {required:true,trigger:'blur',message: "Please enter your title"}
        ],
        tel: [
          {required:true,trigger:'blur',message: "Please enter your tel"}
        ],
        address: [
          {required:true,trigger:'blur',message: "Please enter your address"}
        ],
        city: [
          {required:true,trigger:'blur',message: "Please enter your city"}
        ],
        country: [
          {required:true,trigger:'blur',message: "Please enter your country"}
        ],
      }
    }
  },
  mounted() {
    this.registerForm.confId = window.sessionStorage.getItem("id")
  },
  methods: {
    //取消按钮
    toLogin(){
      let id = window.localStorage.getItem("id")
      window.sessionStorage.setItem("id",id)
      this.$router.push('/login?id='+id)
      this.$store.state.active1=1
      this.$refs.registerFormRef.resetFields();
    },
    register(){
      this.$refs.registerFormRef.validate(async valid => {
        if(valid){
          // 验证邮箱
          const email = this.registerForm.email;
          const emailValid = await this.verifyEmail(email);
          if (!emailValid) {
            return this.$message.error('Email is already registered or invalid');
          }
          const { data: res } = await this.$http.post('api/register',this.registerForm)
          console.log(res);
          if(res.code === 200) {
            this.$message.success('Registered successfully')
            // this.active1+=1
            this.$store.dispatch('addActive1');
          } else if (res.code === 500) return this.$message.error(res.msg)
        } else return false
        this.$refs.registerFormRef.resetFields();
      })
    },
    // 邮箱验证方法
    async verifyEmail(email) {
      try {
        const response = await this.$http.get(`api/register/emailVerify/${email}`);
        console.log(response,'验证')
        // return response.data.code === 200;
      } catch (error) {
        return false; // 如果请求失败，则返回false
      }
    },
    //发送验证码按钮
    sendMessage(){
      this.$refs.registerFormRef.validateField('phonenumber',async valid => {
        if (valid) return
        const { data: res } = await this.$http.post('/api/register/SMSVerify/'+this.registerForm.phonenumber)
        console.log(res);
        if (res.code !== 200) return this.$message.error(res.msg)
        // this.registerForm.yzcode = res.data
        this.$message.success('Send a success')
        this.isSend = false;
        let timer = 60;
        this.sendmsg = timer + "s";
        this.timeFun = setInterval(() => {
          --timer;
          this.sendmsg = timer + "s";
          if (timer === 0) {
            this.isSend = true;
            this.sendmsg = "To resend";
            clearInterval(this.timeFun);
          }
        }, 1000);
      })
    },
    toLast(){
      this.$store.dispatch('subActive1');
      this.$refs.registerFormRef.resetFields();
    }
  },
  watch: {
    '$store.state.active1': function () {
      // console.log(1);
      this.active1=this.$store.state.active1
      // console.log(this.img);
    }
  },
  destroyed() {
    this.$store.state.active1=1
  }
}
</script>

<style lang="less" scoped>
.register_container{
  //background-color: #35597b;
  background-color: #4380b7;
  //opacity: 0.9;
  min-height: 718px;
}
.register_box{
  width: 1000px;
  height: 100%;
  //background-color: #fff;
  background-color: #E9EEF3;
  border-radius: 3px;
  border: 1px solid rgba(255,255,255,.3);
  -moz-box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -webkit-box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  box-shadow: 0 3px 0 rgba(12, 12, 12, 0.03);
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  margin: 0 auto;
}
.btns{
  margin-left: 130px;
  width: 100%;
  padding: 20px 25px;
  .button1{
    height: 37px;
    margin-right: 15px;
  }
  .button2{
    height: 37px;
    margin-right: 15px;
  }
  .button3{
    height: 37px;
  }
}
.register_form{
  width: 80%;
  height: 100%;

  //position: absolute;
  margin-top: 80px;
  //box-sizing: border-box;
  //background-color: red;
}
.link1{
  position: absolute;
  right: 100px;
  top: 50px;
  font-size: 15px;
}
.link2{
  position: absolute;
  left: 50px;
  top: 35px;
  font-size: 20px;
}
.verticalLine{
  width: 5px;
  height: 35px;
  display: flex;
  float: left;
  margin-left: 15px;
  margin-top: 100px;
  background-color:#409EFF;
}
.title1{
  color: #409EFF;
}
.verticalLine2{
  width: 5px;
  height: 35px;
  display: flex;
  float: left;
  margin-left: -135px;
  margin-top: -70px;
  background-color:#409EFF;
}
.title2{
  float: left;
  display: flex;
  margin: -65px 0 20px -105px;
  color: #409EFF;
}
</style>
